import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './Chart.css'
import {Doughnut} from 'react-chartjs'
import { LinkIcon } from '../'
// import format from '../../helpers/format'

@CSSModules(Styles)
export default class Chart extends Component {
  static propTypes = {
    gefScore: PropTypes.string,
    gefStyle: PropTypes.string,
    type: PropTypes.string,
  }
  constructor(props){
    super(props)
  }

  render() {
    const colorDict = {
      'percentile-null':'#E1E1E1',
      'percentile-10':  '#eb1c24',
      'percentile-20':  '#f54929',
      'percentile-30':  '#fe7328',
      'percentile-40':  '#ff981d',
      'percentile-50':  '#febb0a',
      'percentile-60':  '#ffd301',
      'percentile-70':  '#cfcf0d',
      'percentile-80':  '#88c424',
      'percentile-90':  '#3cb33f',
      'percentile-100': '#01a652'
    }

    const { gefScore, gefStyle, type } = this.props

    const isLarge = (type === 'large')
    const isUnscored = (gefScore === '-1')

    const size = isLarge ? 200 : 100
    const circleSize = isLarge ? 85 : 70

    const unscoredChartDate = [
      {
        value: 100,
        color: '#E1E1E1'
      }
    ]

    const scoredChartData = [
      {
        value: gefScore,
        color: colorDict[gefStyle]
      },
      {
        value: 100 - gefScore,
        color: '#E1E1E1'
      }
    ]

    const chartOptions = {
      animation: !isUnscored,
      segmentStrokeWidth: 0,
      percentageInnerCutout: circleSize,
      animationEasing: 'easeOutQuad',
      showTooltips: false
    }

    const chartData = isUnscored ? unscoredChartDate : scoredChartData
    const label = isUnscored ? 'Unscored' : '/ 100 points'

    return (
      <div styleName='chart'>
        <Doughnut
          data={chartData}
          options={chartOptions}
          width={size}
          height={size}
        />
        {
          isLarge ?
            (
              <div styleName='chart-details'>
                {
                  isUnscored ?
                    (
                      <div styleName='chart-ban'>
                        <LinkIcon nospace faclass='fa-ban'/>
                      </div>
                    ) :
                    (
                      <div styleName='chart-assets'>
                        {gefScore}
                      </div>
                    )
                }
                <div>{label}</div>
              </div>
            ) :
            null
        }

      </div>
    )
  }
}

